//# sourceMappingURL=checkbox.mjs.map
/// <reference types="./checkbox.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $cypress from "../../ds/cypress.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $s from "../../ds/internals/styles/checkbox.mjs";
import * as $utils from "../../ds/utils.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Checked extends $CustomType {}
export const State$Checked = () => new Checked();
export const State$isChecked = (value) => value instanceof Checked;

export class Unchecked extends $CustomType {}
export const State$Unchecked = () => new Unchecked();
export const State$isUnchecked = (value) => value instanceof Unchecked;

export class Indeterminate extends $CustomType {}
export const State$Indeterminate = () => new Indeterminate();
export const State$isIndeterminate = (value) => value instanceof Indeterminate;

function is_checked(state) {
  if (state instanceof Checked) {
    return true;
  } else if (state instanceof Unchecked) {
    return false;
  } else {
    return true;
  }
}

export function checkbox(state, disabled, on_check) {
  let checked$1 = is_checked(state);
  return $s.label(
    toList([$utils.stop_propagation()]),
    toList([
      $s.input(
        toList([
          $a.type_("checkbox"),
          $a.checked(checked$1),
          $a.disabled(disabled),
          $cypress.data("checkbox"),
          $e.on_change(
            (_) => {
              on_check(!checked$1);
              return undefined;
            },
          ),
        ]),
      ),
      $s.checkbox(
        checked$1,
        disabled,
        toList([]),
        toList([
          (() => {
            if (state instanceof Checked) {
              return $s.icon($icons.checkmark());
            } else if (state instanceof Unchecked) {
              return $h.none();
            } else {
              return $s.icon($icons.minus());
            }
          })(),
        ]),
      ),
    ]),
  );
}

export function checked(checked) {
  if (checked) {
    return new Checked();
  } else {
    return new Unchecked();
  }
}
